import { cx } from '@emotion/css';
import { Trans } from '@sortlist-frontend/translation/ssr';

import { SectionsDetails } from '_features/AgencyProfile/components/SectionsDetails';
import * as S from '_features/AgencyProfile/components/ServicesPanel/styles';
import type { Section } from '_features/AgencyProfile/utils';

import { ServiceWork } from './ServiceWork';
import type { ServiceWorkNode } from './types';

interface Props {
  serviceName: string;
  worksCount: number;
  works: ServiceWorkNode[];
  className?: string;
  handleActivePanel: (value: Section | undefined) => void;
}

export const ServiceWorks = (props: Props) => {
  const { className, serviceName, works, worksCount, handleActivePanel } = props;
  const maxNumberOfCardsDisplayed = 4;

  const workSlugs = works.map((work) => work.slug);

  return (
    <section className={cx(className, 'p-4 layout-column')}>
      <header className="p-2">
        <Trans i18nKey={'agency:profile.services.worksTitle'} count={worksCount}>
          <b>Works</b> in {{ serviceName }} ({{ count: worksCount }})
        </Trans>
      </header>
      <div className="layout-row p-2">
        <div className="flex-1 layout-row layout-wrap">
          {works.slice(0, maxNumberOfCardsDisplayed).map((work, index) => (
            <ServiceWork
              key={`${work.name}-${index}`}
              index={index}
              work={work}
              serviceName={serviceName}
              workSlugs={workSlugs}
            />
          ))}
          {worksCount > maxNumberOfCardsDisplayed && (
            <div className="pr-2 pb-2 flex-xs-100 flex-sm-33 flex-gt-sm-20">
              <S.ItemExpand
                size="lg"
                buttonStyle="secondary"
                className="layout-fill bg-secondary-200 text-secondary-500"
                label={`+${worksCount - maxNumberOfCardsDisplayed}`}
                onClick={() => handleActivePanel(SectionsDetails?.find((section) => section.id === 'portfolio'))}
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
